module.exports = __webpack_public_path__ + "static/media/our_client_background.654e6d7f.svg";